import { CurrencyAmountDto } from '../types/dtos/currency-amount'
import { CurrencyAmountModel } from '../types/models/currency-amount'

export const transformCurrencyAmountDto = ({
  amount,
  currency_code,
}: CurrencyAmountDto): CurrencyAmountModel => {
  return {
    amount,
    currencyCode: currency_code,
  }
}
